import { Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { LinkService } from 'src/app/services/general/link.service';


@Component({
  selector: 'app-about-home',
  templateUrl: './about-home.page.html',
  styleUrls: ['./about-home.page.scss'],
})
export class AboutHomePage implements OnInit, OnDestroy {

  /**
   * Constructor
   * @param router Router
   */
  constructor(
    private router: Router,
    private linkService: LinkService,
  ) { }

  ngOnInit(): void {
      
  }

  ngOnDestroy(): void {
      
  }

  /**
   * Go back
   */
  goBack() {
    this.linkService.goMainPage();
  }

  /**
   * Go company page
   */
  goCompanyPage() {
    this.router.navigate(['/about/company']);
  }

  /**
   * Go data protection page
   */
  goDataProtectionPage() {
    this.router.navigate(['/about/data-protection']);
  }

  /**
   * Go privacy page
   */
  goPrivacyPage() {
    this.router.navigate(['/about/privacy']);
  }

  /**
   * Go term page
   */
  goTermPage() {
    this.router.navigate(['/about/term']);
  }

  /**
   * Go FAQ page
   */
  goFaqPage() {
    this.router.navigate(['/about/faq']);
  }

  /**
   * Go contact page
   */
  goContactPage() {
    this.router.navigate(['/about/contact']);
  }

  // async deleteTestUser() {
  //   await this.platform.ready();
  //   await this.popupService.presentLoading();
  //   const param = {
  //     uid: '',
  //     password: ''
  //   };
  //   await this.fns.httpsCallable('deleteTestUserCall')(param).toPromise().then(async (result) => {
  //     console.log("🚀 ~ file: about-home.page.ts ~ line 78 ~ AboutHomePage ~ awaitthis.fns.httpsCallable ~ result", result)
  //   }).catch((err: any) => {
  //     console.log("🚀 ~ file: about-home.page.ts ~ line 80 ~ AboutHomePage ~ awaitthis.fns.httpsCallable ~ err", err)
  //   });
  //   this.popupService.dismissLoading();
  // }
}
